import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import { ConBrandWebV1FindResponse } from '@/services/swagger/data-contracts';
import BrandSubscriptionButton from '@/business-components/BrandSubscriptionButton';
import BrandCollectionButton from '@/business-components/BrandCollectionButton';
import LogoWithText from '@/business-components/LogoWithText';
import styles from './index.module.scss';

export type BrandInfoProps = {
  /** 品牌id */
  brandId: string;
  /** 是否认证品牌方 */
  isBrandVendor?: boolean;
  /** 是否已订阅 */
  subscribed?: boolean;
  /** 是否已收藏 */
  collected?: boolean;
  /** 订阅状态改变回调 */
  onSubscriptionStateChange?: (value: boolean) => void;
  /** 收藏状态改变回调 */
  onCollectionStateChange?: (value: boolean) => void;
  /** 邮箱留资成功回调 */
  onSubmitEmailSuccess?: () => void;
} & ConBrandWebV1FindResponse;

const BrandInfo: React.FC<BrandInfoProps> = ({
  brandId,
  isBrandVendor,
  subscribed,
  collected,
  onSubscriptionStateChange,
  onCollectionStateChange,
  onSubmitEmailSuccess,
  ...props
}) => {
  const onSubscriptionBtnValueChange = useCallback(
    value => {
      onSubscriptionStateChange?.(value);
    },
    [onSubscriptionStateChange]
  );
  const onCollectionBtnValueChange = useCallback(
    value => {
      onCollectionStateChange?.(value);
    },
    [onCollectionStateChange]
  );
  return (
    <div className={classNames('flex-row-nowrap', styles.brandInfo)}>
      <LogoWithText
        src={props?.logoUrl}
        width={70}
        borderRadios={12}
        chName={props?.chName}
        ehName={props?.ehName}
        logoClass={styles.brandImg}
        spanClass={styles.logoSpan}
        len={6}
      />

      <div className={styles.brandInfoContent}>
        <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.brandName)}>
          {props?.chName && <div className={classNames(styles.name, styles.chName)}>{props?.chName}</div>}
          <div className={classNames(styles.name, styles.enName)}>{props?.ehName}</div>
          {isBrandVendor && (
            <img
              className={styles.verificationIcon}
              src="//assets-oss.cbndata.com/cbndata-refactor-fe/FlLf7gQH8pbLHQ525HXRTjB9Hu6u.svg"
              alt="品牌方已认证"
            />
          )}
          <BrandSubscriptionButton
            brandId={brandId}
            subscribed={subscribed}
            onChange={onSubscriptionBtnValueChange}
            onSubmitEmailSuccess={onSubmitEmailSuccess}
          />
          <BrandCollectionButton
            className={styles.collectionBtn}
            brandId={brandId}
            active={collected}
            onChange={onCollectionBtnValueChange}
          />
        </div>
        <div className={classNames('flex-row-nowrap', styles.brandIndustry)}>
          <div>{props?.industryTrackName}</div>&nbsp;|&nbsp;
          <div>
            {/* {props?.oneLevelTrackName}-{props?.twoLevelTrackName} */}
            {props?.oneLevelTrackName}
          </div>
        </div>
        {/* <div className={styles.description}>{props?.brandDesc}</div> */}
        <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.brandInformation)}>
          <span className={styles.icon}>
            <svg className="icon" aria-hidden="true">
              <use xlinkHref="#icon-location" />
            </svg>
          </span>
          <span>{['中国', props.companyProvince].filter(Boolean).join('-')}</span>
          {props?.foundingTimeYear && (
            <>
              &nbsp;|&nbsp;
              <span>{props?.foundingTimeYear}年成立</span>
            </>
          )}
          {props?.companyChName && (
            <>
              &nbsp;|&nbsp;
              <span>{props?.companyChName}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(BrandInfo);
